import React from 'react';
import { Platform, View } from 'react-native';
import { withTheme } from '@rneui/themed';
import { useIsEntitledQuery } from '@annunciate/query';
import { BuyButton } from '@annunciate/ui/dist/components/buttons/BuyButton';
import { FavoriteButton, ProgressButton } from '@annunciate/ui/dist/components/content';
import { DownloadButton } from '@annunciate/ui/dist/components/content/DownloadButton';
import { ShareItemButton } from '@annunciate/ui/dist/components/shared/ShareItemButton';
import { Row } from '../elements';
import { PlayButton } from '../player';
import { TagButton } from '../tag';
export const UnthemedListItemButtons = ({ item, showDownload = true, showProgress = true, showPlay = true, fullBarStyle, }) => {
    const isEntitled = useIsEntitledQuery(item);
    let isDownload = false;
    if (item.__typename === 'Content') {
        isDownload = !!item?.isDownload;
    }
    return (React.createElement(Row, { style: fullBarStyle },
        showDownload && (React.createElement(DownloadButton, { item: item, isLeftAligned: true })),
        showProgress && (React.createElement(ProgressButton, { item: item, isLeftAligned: !showDownload || Platform.OS === 'web' })),
        React.createElement(FavoriteButton, { item: item, isLeftAligned: !showDownload && !showProgress }),
        React.createElement(TagButton, { item: item }),
        React.createElement(ShareItemButton, { item: item }),
        React.createElement(View, { style: { flexGrow: 1 } }),
        showPlay && ((isEntitled || isDownload) ? (React.createElement(PlayButton, { content: item, isRightAligned: true })) : (React.createElement(BuyButton, { item: item })))));
};
export const ListItemButtons = withTheme(UnthemedListItemButtons, 'ListItemButtons');
//# sourceMappingURL=ListItemButtons.js.map